// eslint-disable-next-line import/prefer-default-export
export function numberWithDelimiter(number, delimiter = '.') {
  return Math.round(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, delimiter)
}
